// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  subId: __t.u64().primaryKey().name("sub_id"),
  patron: __t.identity(),
  creator: __t.identity(),
  kind: __t.string(),
  amountSov: __t.i64().name("amount_sov"),
  periodDays: __t.u32().name("period_days"),
  nextChargeAt: __t.timestamp().name("next_charge_at"),
  active: __t.bool(),
  createdAt: __t.timestamp().name("created_at"),
});
